import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ActionPlanRoutingModule } from './action-plan.routing';
import { ActionPlanListPageComponent } from '../pages/list.component';
import { ActionPlanListComponent } from '../components/list.component';
import { SharedModule } from '../../shared.module';
import { ActionPlanDetailPageComponent } from '../pages/detail.component';
import { ActionPlanDetailComponent } from '../components/detail.component';
import { ResponsibleDetailPageComponent } from '../pages/responsible-detail.component';
import { ResponsibleDetailComponent } from '../components/responsible-detail.component';
import { ActionPlanItemDetailComponent } from '../components/item-detail.component';
import { ActionPlanItemDetailPageComponent } from '../pages/item-detail.component';
import { ActionPlanItemStatusComponent } from '../components/item-status.component';
import { ActionPlanItemStatusEditPageComponent } from '../pages/item-status-edit.component';
// reports
import { ActionPlanReportPdfListPageComponent } from '../pages/report-pdf-list.component';
import { ActionPlanCollaboratePageComponent } from '../pages/collaborate.component';

import { PluginModule } from '../../plugins/modules';
import { ActionPlanMenuComponent } from '../../menus/action-plan.menu';
import { ActionPlanListMenuComponent } from '../../menus/action-plan-list.menu';
import { ActionPlanItemsMenuComponent } from '../../menus/action-plan-items.menu';

@NgModule({
  imports: [PluginModule, ActionPlanRoutingModule, SharedModule, CommonModule, FormsModule, ReactiveFormsModule],

  declarations: [
    ActionPlanListPageComponent,
    ActionPlanListComponent,
    ActionPlanDetailPageComponent,
    ActionPlanDetailComponent,
    ResponsibleDetailPageComponent,
    ResponsibleDetailComponent,
    ActionPlanMenuComponent,
    ActionPlanListMenuComponent,
    ActionPlanItemsMenuComponent,
    ActionPlanItemDetailPageComponent,
    ActionPlanItemDetailComponent,
    ActionPlanReportPdfListPageComponent,
    ActionPlanItemStatusComponent,
    ActionPlanItemStatusEditPageComponent,
    ActionPlanCollaboratePageComponent
  ]
})
export class ActionPlanModule {}
